import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import Swal from 'sweetalert2';

import Button from '../common/Button';
import { apiUrl } from '../../config/api';
import './LoginModal.scss';

const ForgetPassModel = ({ show, onClose }) => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [formError, setFormError] = useState(null);

  useEffect(() => {
    if (!show) setFormError(null);
  }, [show]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (loading) return;

    setLoading(true);
    setFormError(null);
    try {
      const response = await fetch(apiUrl('/api/forgot-password'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      const data = await response.json().catch(() => ({}));

      // The old version always claimed success, even on a 4xx/5xx.
      if (!response.ok) {
        setFormError(data.message || 'We could not send the reset link.');
        return;
      }

      onClose();
      setEmail('');
      Swal.fire({
        icon: 'success',
        confirmButtonColor: '#b63f23',
        title: 'Check your inbox for the reset link.',
      });
    } catch {
      setFormError('Something went wrong. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>Reset your password</Modal.Header>
      <Modal.Body>
        <div className="ij-auth">
          <form className="ij-auth__form" onSubmit={handleSubmit} noValidate>
            <p className="ij-text-muted">
              Enter the email you signed up with and we&apos;ll send you a link
              to set a new password.
            </p>

            <div className="ij-field">
              <label className="ij-label" htmlFor="forgot-email">
                Email address
              </label>
              <input
                id="forgot-email"
                type="email"
                className="ij-input"
                autoComplete="email"
                placeholder="you@example.com"
                value={email}
                required
                disabled={loading}
                aria-invalid={formError ? 'true' : undefined}
                onChange={(event) => setEmail(event.target.value)}
              />
            </div>

            {formError && (
              <p className="ij-alert ij-alert--error" role="alert">
                {formError}
              </p>
            )}

            <Button
              type="submit"
              variant="primary"
              block
              loading={loading}
              loadingText="Sending…"
            >
              Send reset link
            </Button>
          </form>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ForgetPassModel;
